export type GlobalSetting = {
  id: string;
  key: string;
  value: string;
  description?: string | null;
  created_at: string;
  updated_at: string;
};

/**
 * Global Setting Keys
 * Static definitions for global setting keys used across the application
 */
export const GLOBAL_SETTING_KEYS = {
  DISABLE_RING_SIGNUP: 'disable_ring_signup',
} as const;
